<p-toast [baseZIndex]="900000" [preventOpenDuplicates]="false" [style]="{ marginTop: '80px' }"></p-toast>

<div class="Light-nav">
  <div class="logo-wrapper">
    <img (click)="toHome()" style="cursor: pointer;" src="assets/icons/Logo.JPG" alt="" />
  </div>
  <div class="Light-nav-content">
    <div class="Light-support-wrap">
      <h2 class="Light-nav-heading">Archery association of India</h2>
      <img class="Light-head-support" src="assets/icons/target.svg" alt="" />
    </div>
    <p class="Light-nav-text" style="margin-top: 20px">
      Archery Association of India came into existence in 1973, with the primary
      objective to organize, encourage, and promote the game of Archery in the
      country by providing proper training facilities to Indian Archers.
    </p>
  </div>
</div>

<div class="register-wrapper">
  <div class="flex">
    <img class="back-Arrow-Register" (click)="toRoles()" src="assets/icons/backArrow.svg" />
    <h2 Class="FormMainTitle">Coach Registration Form</h2>
  </div>
  <div #stickyMenu [class.sticky]="sticky" class="progress-wrap">
    <p>Form completion</p>
    <p-progressBar [value]="value"></p-progressBar>
  </div>

  <form [formGroup]="coachFormGroup" (ngSubmit)="onSubmit()">
    <div class="register-card-wrapper">
      <h1 class="register-card-title">Personal Information</h1>
      <p class="register-card-text">Enter your personal details</p>
      <div class="register-card">
        <div class="ui-g">
          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">Full Name <span class="required">*</span></label>
              <input type="text" formControlName="fullName" class="form-control-register" />
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="f.fullName.errors && f.fullName.errors.required">
                  Full Name is required
                </div>
              </div>
            </div>
          </div>

          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">Gender <span class="required">*</span></label>
              <div class="drop-area">
                <p-dropdown [options]="genderList" formControlName="gender"></p-dropdown>
              </div>
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="f.gender.errors && f.gender.errors.required">
                  Gender is required
                </div>
              </div>
            </div>
          </div>
          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">AAI Member State Associations/Units<span class="required">*</span>
              </label>
              <div class="drop-area">
                <p-dropdown placeholder="Select" [options]="memberAssociation" formControlName="memberAssociation">
                </p-dropdown>
              </div>
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="
                    f.memberAssociation.errors &&
                    f.memberAssociation.errors.required
                  ">
                  Required
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ui-g">
          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">Date of birth <span class="required">*</span></label>
              <div class="calendar">
                <p-calendar dateFormat="dd/mm/yy" [yearNavigator]="true" yearRange="1940:2024" formControlName="dob">
                </p-calendar>
              </div>
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="f.dob.errors && f.dob.errors.required">
                  Dob is required
                </div>
              </div>
            </div>
          </div>

          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">Phone <span class="required">*</span></label>
              <!-- <input type="number" formControlName="phone" class="form-control-register" /> -->
              <div id="input-wrapper">
                <label for="number">+91 - </label>
                <input type="number" formControlName="phone" class="form-control-register" />
              </div>
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="f.phone?.errors?.required">Number is required</div>
              </div>
              <div class="invalid-feedback" *ngIf="f.phone?.errors?.min || f.phone?.errors?.max">
                Please enter a 10 digit mobile number
              </div>
            </div>
          </div>
          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">Email Id <span class="required">*</span></label>
              <input type="text" formControlName="email" class="form-control-register" [readonly]="isEmailVerified"/>
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="f.email?.errors?.required">Email is required</div>
              </div>
              <div class="invalid-feedback" *ngIf="f.email?.errors?.pattern">
                Email must be a valid email address
              </div>
              <div *ngIf="isEmailInvalid()" class="invalid-feedback">
                Email is required
              </div>
            </div>
          </div>
        </div>

        <div class="ui-g">
          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group" style="position: relative">
              <label class="label">Password <span class="required">*</span></label>
              <input [type]="eyeShow ? 'text' : 'password'" formControlName="password" class="form-control-register" />
              <img class="eye" *ngIf="!eyeShow" src="assets/icons/eye.svg" (click)="togglePassword()" alt="" />
              <img class="eye" *ngIf="eyeShow" src="assets/icons/sight.svg" (click)="togglePassword()" alt="" />
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="f.password.errors && f.password.errors.required">
                  Password is required
                </div>
              </div>
            </div>
          </div>

          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">Event <span class="required">*</span></label>
              <div class="drop-area">
                <p-multiSelect placeholder="Select" [options]="eventList" [filter]="false" formControlName="eventName">
                </p-multiSelect>
              </div>
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="f.eventName.errors && f.eventName.errors.required">
                  Event is required
                </div>
              </div>
            </div>
          </div>

          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">NIS / Certificate Course (6 Week) / Non-NIS
                <span class="required">*</span>
              </label>
              <div *ngFor="let data of NIS; let i = index" class="ui-g-12">
                <p-radioButton name="group1" value="{{ data.value }}" label="{{ data.label }}"
                  formControlName="certificateType" inputId="i">
                </p-radioButton>
              </div>
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="
                    f.certificateType.errors &&
                    f.certificateType.errors.required
                  ">
                  Required
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ui-g">
          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">Aadhar Card Number <span class="required">*</span></label>
              <input type="number" formControlName="aadharCard" class="form-control-register" />
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="f.aadharCard?.errors?.required">
                  Aadhar Card is required
                </div>
              </div>
            </div>
          </div>

          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <p class="sub-text">
              Upload Aadhar Card/ Masked Adhaar Card/ Driving License/ Passport <span class="required">*</span>
            </p>
            <div class="file-info-wrapper">
              <div class="upload-wrap-form">
                <label for="fileInputAadhar">
                  <img *ngIf="!aadhar" class="upload-image" id="AdharIcon" src="assets/icons/browse.svg" />
                  <img *ngIf="aadhar && aadharFormat === 'image'" class="upload-image" id="AdharIcon"
                    [src]="global?.basePathImage + aadharNewFile" />
                  <img *ngIf="aadhar && aadharFormat === 'document'" class="upload-image" id="AdharIcon"
                    src="assets/icons/docIcon.svg" />
                </label>

                <input accept=".png,.jpg" id="fileInputAadhar" type="file" #fileuploadAadhar
                  (change)="UploadAadhar(fileuploadAadhar.files)" />
              </div>
              <div class="file-info">
                <p>Maximum upload File Size:<strong> 3MB </strong></p>
                <p>File type Supported:<strong> .png, .Jpg </strong></p>
              </div>
            </div>

            <div *ngIf="submitted" class="invalid-feedback" style="margin-left: 8px">
              <div *ngIf="f.aadharImage.errors && f.aadharImage.errors.required">
                Required
              </div>
            </div>
          </div>
        </div>
        <p *ngIf="mainValidation" class="invalid-feedback" style="text-align: right">
          {{ mainMessage }}
        </p>
      </div>
      <div *ngIf="!otherBox && isEmailVerified" (click)="openBox()" class="next-button">Next</div>
      <div *ngIf="!isEmailVerified" class="next-button" (click)="openVerifyModel()">
        Send Otp
      </div>
    </div>

    <div *ngIf="otherBox" class="register-card-wrapper">
      <h1 class="register-card-title">Other Details</h1>
      <p class="register-card-text">Fill out your other details</p>
      <div class="register-card">
        <div class="ui-g">
          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">Employed <span class="required">*</span></label>
              <div class="drop-area">
                <p-dropdown [options]="employed" formControlName="employementStatus"></p-dropdown>
              </div>
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="
                    f.employementStatus.errors &&
                    f.employementStatus.errors.required
                  ">
                  Required
                </div>
              </div>
            </div>
          </div>
          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">Employment Details</label>
              <div class="drop-area">
                <p-dropdown [options]="employmentDetails" formControlName="employmentDetails" [editable]="true">
                </p-dropdown>
              </div>
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="
                    f.employmentDetails.errors &&
                    f.employmentDetails.errors.required
                  ">
                  Employment details required
                </div>
              </div>
            </div>
          </div>
          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">Engaged with / Place of Posting </label>
              <input type="text" formControlName="postingPlace" class="form-control-register" />
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="
                    f.postingPlace.errors && f.postingPlace.errors.required
                  ">
                  Posting Place is required
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ui-g">
          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">Date since training Started as Archer
                <span class="required">*</span></label>
              <div class="calendar">
                <p-calendar dateFormat="dd/mm/yy" formControlName="trainingStartedArcherYear" [yearNavigator]="true"
                  yearRange="1940:2024"></p-calendar>
              </div>
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="
                    f.trainingStartedArcherYear.errors &&
                    f.trainingStartedArcherYear.errors.required
                  ">
                  Required
                </div>
              </div>
            </div>
          </div>
          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">Highest performance as a player
                <span class="required">*</span></label>
              <input type="text" formControlName="performanceAsPlayer" class="form-control-register" />
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="
                    f.performanceAsPlayer.errors &&
                    f.performanceAsPlayer.errors.required
                  ">
                  Performance as player is required
                </div>
              </div>
            </div>
          </div>
          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">Date of Archery Coaching <span class="required">*</span></label>
              <div class="calendar">
                <p-calendar dateFormat="dd/mm/yy" formControlName="coachingYear" [yearNavigator]="true"
                  yearRange="1940:2024">
                </p-calendar>
              </div>
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="
                    f.coachingYear.errors && f.coachingYear.errors.required
                  ">
                  Required
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ui-g">
          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">Performance as a coach <span class="required">*</span></label>
              <input type="text" formControlName="performanceAsCoach" class="form-control-register" />
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="
                    f.performanceAsCoach.errors &&
                    f.performanceAsCoach.errors.required
                  ">
                  required
                </div>
              </div>
            </div>
          </div>
          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group">
              <label class="label">Awards and Recognition</label>
              <input type="text" formControlName="nationalAwards" class="form-control-register" />
              <div *ngIf="submitted" class="invalid-feedback">
                <div *ngIf="
                    f.nationalAwards.errors && f.nationalAwards.errors.required
                  ">
                  Required
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ui-g">
          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <p class="sub-text">
              Upload Resume <span class="required">*</span>
            </p>
            <div class="file-info-wrapper">
              <div class="upload-wrap-form">
                <label for="fileInputResume">
                  <img *ngIf="!Resume" class="upload-image" id="ResumeIcon" src="assets/icons/browse.svg" />
                  <img *ngIf="Resume && ResumeFormat === 'image'" class="upload-image" id="ResumeIcon"
                    [src]="global?.basePathImage + ResumeFile" />
                  <img *ngIf="Resume && ResumeFormat === 'document'" class="upload-image" id="ResumeIcon"
                    src="assets/icons/docIcon.svg" />
                </label>

                <input accept=".png,.jpg,.pdf" id="fileInputResume" type="file" #fileuploadResume
                  (change)="UploadResume(fileuploadResume.files)" />
              </div>
              <div class="file-info">
                <p>Maximum upload File Size:<strong> 3MB </strong></p>
                <p>File type Supported:<strong> .png, .Jpg, .pdf </strong></p>
              </div>
            </div>

            <div *ngIf="submitted" class="invalid-feedback" style="margin-left: 8px">
              <div *ngIf="f.resumeLink.errors && f.resumeLink.errors.required">
                Required
              </div>
            </div>
          </div>

          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <p class="sub-text">
              Upload Signature <span class="required">*</span>
            </p>
            <div class="file-info-wrapper">
              <div class="upload-wrap-form">
                <label for="fileInputSignature">
                  <img *ngIf="!signature" class="upload-image" id="SigIcon" src="assets/icons/browse.svg" />
                  <img *ngIf="signature && signatureFormat === 'image'" class="upload-image" id="SigIcon"
                    [src]="global?.basePathImage + signatureNewFile" />
                  <img *ngIf="signature && signatureFormat === 'document'" class="upload-image" id="SigIcon"
                    src="assets/icons/docIcon.svg" />
                </label>

                <input accept=".png,.jpg" id="fileInputSignature" type="file" #fileuploadSignature
                  (change)="UploadSignature(fileuploadSignature.files)" />
              </div>
              <div class="file-info">
                <p>Maximum upload File Size:<strong> 3MB </strong></p>
                <p>File type Supported:<strong> .png, .Jpg </strong></p>
              </div>
            </div>

            <div *ngIf="submitted" class="invalid-feedback" style="margin-left: 8px">
              <div *ngIf="
                  f.signatureLink.errors && f.signatureLink.errors.required
                ">
                Required
              </div>
            </div>
          </div>

          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group" style="position: relative">
              <div style="display: 'flex'">
                <label class="label">Professional Qualification </label>
                <div class="add-qualification" (click)="addProfession()">
                  Add More
                </div>
              </div>
              <div formArrayName="professionalQualification"
                *ngFor="let quantity of professional().controls; let i = index">
                <div [formGroupName]="i">
                  <input type="text" formControlName="name" class="form-control-register add-qualification-input" />
                  <p *ngIf="i > 0" class="RemoveFormArray" (click)="deleteProfession(i)">
                    Remove
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ui-g">
          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div class="form-group" style="position: relative">
              <div style="display: 'flex'">
                <label class="label">Educational Qualification </label>
                <div class="add-qualification" (click)="addEducation()">
                  Add More
                </div>
              </div>
              <div formArrayName="educationQualification"
                *ngFor="let quantity of educational().controls; let i = index">
                <div [formGroupName]="i">
                  <input type="text" formControlName="name" class="form-control-register add-qualification-input" />
                  <p *ngIf="i > 0" class="RemoveFormArray" (click)="deleteEducation(i)">
                    Remove
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <p class="sub-text">
              Upload Profile Pic <span class="required">*</span>
            </p>
            <div class="file-info-wrapper">
              <div class="upload-wrap-form">
                <label for="fileInputPic">
                  <img *ngIf="!imageUpload" class="upload-image" id="PicIcon" src="assets/icons/browse.svg" />
                  <img *ngIf="imageUpload" class="upload-image" id="PicIcon"
                    [src]="global?.basePathImage + signatureFile" />
                </label>

                <input id="fileInputPic" accept=".png,.jpg" type="file" #fileuploadPic
                  (change)="fileChange(fileuploadPic.files)" />
              </div>
              <div class="file-info">
                <p>Maximum upload File Size:<strong> 3MB </strong></p>
                <p>File type Supported:<strong> .png, .Jpg </strong></p>
              </div>
            </div>

            <div *ngIf="submitted" class="invalid-feedback">
              <div *ngIf="f.profileImage.errors && f.profileImage.errors.required">
                Required
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align: right">
        <button class="authButton saveBut" type="submit">
          <span *ngIf="logSpinner"><i class="pi pi-spin pi-spinner" style="margin-right: 6px"></i></span>
          Submit Details
        </button>
      </div>
    </div>
  </form>
</div>

<p-dialog header="User" [(visible)]="termsModel" [modal]="true" styleClass="mydialog" [responsive]="true" [minY]="70"
  [maximizable]="true" [baseZIndex]="10000">
  <div class="Terms-conditions">
    <h1>Terms & Conditions</h1>
    <p>
      Declaration from Applicant prior to filling up the Application Form • I
      hereby confirm that I have read and understood the Instructions, rules and
      regulation mentioned hereunder and apply to Archery Association of India
      for Affiliation. • I agree to abide by the terms, conditions, rules,
      regulations and other statutory requirements applicable. • I hereby
      declare that the particulars given herein are true, correct, complete and
      valid to the best of my knowledge and belief and the documents submitted
      along with this application are genuine. I also understand that any wilful
      misinformation may render for refusal of this application or initiate
      punitive action in form of suspensation, debar or termination. • I hereby
      undertake to promptly inform AAI of any changes to the information
      provided and agree and accept that AAI or its EC Members or its member
      State Archery Associations/Associate Members or its host Associations not
      liable or responsible for any losses, costs, damages arising out of any
      actions undertaken or activities performed by them on the basis of the
      information provided by me as also due to delay in intimating such
      changes. • I hereby agree to provide any additional information /
      documentation that may be required, in connection with this application. •
      I understand that AAI, at its sole discretion, may make and amend terms,
      conditions, rules, regulations, format and other requirements with respect
      to affiliation, eligibility, age-verification, inter-state transfer, fee
      payment etc.time to time, as and when required.
      <br />
      <strong>Key Information </strong>
      <br />

      • The ‘Affiliation Portal’ allows Archers, Coaches, Officials (Technical
      Officials, Team Officials, Others) for affiliation who wish to participate
      in Championships, Games, International and National Tournaments being
      recognized or controlled by World Archery or Archery Association of India
      or its Member Associations. Applicant shall seek affiliation from AAI by
      making payment of an ‘Affiliation Fee’ on an annual calendar year basis,
      at least, two months prior to the end of each calendar year. Such
      affiliation shall be validated/ confirmed within one month thereafter by
      the Member Association of AAI who he/she represents. • The Registration
      shall remain applicable for the annual calendar year, provided there is no
      disciplinary action initiated against such person. ‘Team Officials’ means
      Team Managers/Captains, Physiotherapists, Psychologists, Mental Trainers
      Masseurs, Masseuses etc who accompany with their State/Unit team while
      taking part in any Archery competitions/tournament/event/activities.
      ‘Others’ means Senior functionaries (preferably President, Secretary and
      Treasurer who will get AAI ID cards free of cost) of Member State
      Association/Unit. Member State Association/unit will be provided with an
      option to add officials (not exceed to three) of their respective body in
      profile. • Any person who is willing or even may have any chance to
      participate in competitions/ events during a calendar year should ensure
      his/her affiliation / renewal within the first two months of each calendar
      year (preferably before 28th day of February). • Since the ‘Affiliation
      portal’ would be inter-linked with the ‘Tournament Portal’, therefore,
      only affiliated/ registered persons will be able to participate in the
      tournaments of Archery in the country and abroad. Member State
      Associations/Units must ensure the affiliation of all potential archers,
      coaches, managers etc. of its States/Units well in time in order to avoid
      disqualification/ non- participation. • Applicant must keep all necessary
      details/documents like scanned copy of Aadhar card, Address proof, DoB
      proof, photograph (specified size) handy and available at all times, prior
      to filing up the Online Affiliation Form to upload on the portal.
      Applicant must also have a valid and active email ID and mobile number to
      receive notifications from the system. In case, an Applicant does not have
      a valid personal e-mail ID, he/she must create his/her new e-mail ID and
      mobile number before applying on-line and must maintain that email account
      and mobile number during the continuation of his/ her registration. Any
      notification/ communication with the Applicant shall be made only through
      such email address and mobile number. • Member State Association/Unit of
      the AAI is authorized to validate applications (except AAI accredited
      NTOs) of their respective State/Unit for affiliation with the help of
      documents stated above. Entries validated by the Member Associations/
      Units will only be given affiliation under the portal. System-generated
      notifications will go to the applicants’ personal email id/ mobile numbers
      to notify them about the status (pending/approved/rejected or renewal) of
      their application. Validation through the State Association/ Unit shall be
      duly signed by the President/ Secretary General of such State Association/
      Unit. • Applicant shall not be allowed to register more than one time. Any
      duplicate entry through any other username or password shall lead to
      disciplinary action against such Applicant. However, editing option to
      alter the details of the Applicant is available on portal which allows
      applicant to change their details only after intimating about such change
      to the respective Member State Association / Unit and obtaining their
      approval. • The ‘Affiliation Cards’ would be issued through the portal to
      all the affiliated Archers, Coaches, Officials. Applicant can download
      digital Affiliation Card and must carry it, in physical form, while
      attending the competitions and other events of the Archery Association of
      India. The Affiliation Card is restricted to use by the holder only for
      the purpose of participation in Archery Competitions/
      Tournaments/Events/Activities. • In case, an Archer wishes to play from
      any other member State/Unit other than the one he/she is registered with,
      he/she can do so by providing valid and bonafide reasons in this regard.
      Such change may be permitted, provided, such an Archer has uploaded a ‘No
      Objection Certificates (NOCs) from both the member State
      Associations/Units (from where he/she wishes to play and from where he/she
      has already registered or has played before). AAI will examine such cases
      on the merits of information/documents provided and thereafter take any
      decision for accepting/ rejection such change. Obtaining NOCs, as stated
      above, shall be mandatory for all Archers for change of State/Unit. Please
      note that the existing rules and regulation of AAI for ‘Inter-State
      Transfer of Archers’ shall remain applicable. In case, an Archer
      participates from different state/unit without obtaining approval in the
      manner stated above, an appropriate disciplinary action would be taken
      against such errant Archer.
      <br />

      <strong> TERMS & CONDITIONS </strong>
      <br />

      Welcome to Affiliation Portal of Archery Association of India. This
      document is an electronic record in terms of Information Technology Act,
      2000 and published in accordance with the provisions of Rule 3) of the
      Information Technology (Intermediaries guidelines) Rules, 2011 that
      require publishing the rules and regulations, privacy policy and Terms of
      Use for access or usage of platform - www.indianarchery.info (hereinafter
      referred to as "Platform") The Platform is owned by Archery Association of
      India (hereinafter referred to as AAI), having its registered office at
      Gate No.2, Yamuna Sports Complex, Surajmal Vihar, Delhi, India. Your use
      of the Affiliation Portal and services and tools are governed by the
      following terms and conditions ("Terms of Use") as applicable to the
      website including the applicable policies which are incorporated herein by
      way of reference. By mere use of the website, You shall be contracting
      with AAI, the owner of the Platform. These terms and conditions including
      the policies constitute Your binding obligations, with AAI. For the
      purpose of these Terms of Use, wherever the context so requires "You" or
      "User" shall mean any natural or legal person who has agreed to become a
      buyer on/to use this Platform by providing data while registering on the
      Platform as Registered/Affiliated User. The term "We", "Us","Our" shall
      mean AAI and its affiliates. When You/applicant wishes to affiliate with
      the AAI through the portal any of the services provided by Us through the
      Platform, including but not limited to, (e.g. Product Reviews, Seller
      Reviews), he/she will be subject to the rules, guidelines, policies,
      terms, and conditions applicable to such service, and they shall be deemed
      to be incorporated into this Terms of Use and shall be considered as part
      and parcel of this Terms of Use. We reserve the right, at our sole
      discretion, to change, modify, add or remove portions of these Terms of
      Use, at any time without any prior written notice to You. You/Applicant
      shall ensure to review these Terms of Use periodically for
      updates/changes. Your /applicant continued use of the Platform following
      the posting of changes will mean that You/applicant accepts and agrees to
      the revisions. As long as You/Applicant complies with these Terms of Use,
      We grant You/the applicant a personal, non-exclusive, non-transferable,
      limited privilege to enter and use the Platform. By impliedly or expressly
      accepting these Terms of Use, You/applicant also accepts and agrees to be
      bound by AAI Policies including but not limited to Privacy Policy as
      amended from time to time.
      <br />

      <strong>Introduction </strong>

      <br />

      These Terms and Conditions (hereinafter referred to as “Terms”) contained
      herein on this webpage, shall govern your use of this website, including
      all pages within this website (collectively referred to herein below as
      this “Website”). These Terms apply in full force and effect to your use of
      this Website and by using this Website, you expressly accept all terms and
      conditions contained herein in full. You must not use this Website, if you
      have any objection to any of these Terms and Conditions.
      <br />

      <strong>Intellectual Property Rights </strong>

      <br />

      Other than content you own, which you may have opted to include on this
      Website, under these Terms, AAI and/or its licensors own all rights to the
      intellectual property and material contained in this Website, and all such
      rights are reserved. You are granted a limited license only, subject to
      the restrictions provided in these Terms, for purposes of viewing the
      material contained on this Website.
      <br />

      <strong>Restrictions</strong>

      <br />

      You/Applicants are expressly and emphatically restricted from all of the
      following: • publishing any Website material in any media; • selling,
      sublicensing and/or otherwise commercializing any Website material; •
      publicly performing and/or showing any Website material; • using this
      Website in any way that is, or may be, damaging to this Website; • using
      this Website in any way that impacts user access to this Website; • using
      this Website contrary to applicable laws and regulations, or in a way that
      causes, or may cause, harm to the Website, or to any person or legal
      entity; • engaging in any data mining, data harvesting, data extracting or
      any other similar activity in relation to this Website, or while using
      this Website; • using this Website to engage in any advertising or
      marketing; Certain areas of this Website are restricted from access by
      You/Applicant and AAI may further restrict access by You/Applicant to any
      areas of this Website, at any time, in its sole and absolute discretion.
      Any user ID and password you may have for this Website are confidential
      and you must maintain confidentiality of such information.
      <br />

      <strong>Your/Applicant Content</strong>

      <br />

      In these Terms and Conditions, “Your Content” shall mean any text, images
      or other material you choose to display on this Website. With respect to
      Your Content, by displaying it, you grant AAI a non-exclusive, worldwide,
      irrevocable, royalty-free, sub-licensable license to use, reproduce,
      adapt, publish, translate and distribute it in any and all media. Your
      Content must be your own and must not be infringing on any third party’s
      rights. AAI reserves the right to remove any of Your/Applicant Content
      from this Website at any time, and for any reason, without notice.
      <br />

      <strong>No warranties</strong>

      <br />

      This Website is provided “as is,” with all faults, and AAI makes no
      express or implied representations or warranties, of any kind related to
      this Website or the materials contained on this Website. Additionally,
      nothing contained on this Website shall be construed as providing consult
      or advice to you/applicant.
      <br />

      <strong>Limitation of liability</strong>

      <br />

      In no event AAI or any of its member of Executive Committee or officials
      or employees shall be liable to you/applicant for anything arising out of
      or in any way connected with your use of this Website, whether such
      liability is under contract, tort or otherwise, and AAI, including its
      Executive Committee Members or officials or employees shall not be liable
      for any indirect, consequential or special liability arising out of or in
      any way related to your/applicants’ use of this Website.
      <br />

      <strong>Indemnification</strong>

      <br />

      You/Applicant hereby indemnify to the fullest extent of AAI from and
      against any and all liabilities, costs, demands, causes of action, damages
      and expenses (including reasonable attorney’s fees) arising out of or in
      any way related to your breach of any of the provisions of these Terms.
      <br />

      <strong>Severability</strong>

      <br />

      If any provision of these Terms is found to be unenforceable or invalid
      under any applicable law, such unenforceability or invalidity shall not
      render these Terms unenforceable or invalid as a whole, and such
      provisions shall be deleted without affecting the remaining provisions
      herein.
      <br />

      <strong>Variation of Terms</strong>

      <br />

      AAI is permitted to revise these Terms at any time as it sees fit, and by
      using this Website and you/applicants are expected to review such Terms on
      a regular basis to ensure you understand all terms and conditions
      governing use of this Website.
      <br />

      <strong>Assignment</strong>

      <br />

      AAI shall be permitted to assign, transfer, and subcontract its rights
      and/or obligations under these Terms without any notification or consent
      required. However, You/applicant shall not be permitted to assign,
      transfer, or subcontract any of your rights and/or obligations under these
      Terms. Hyperlinks to Third Party websites From time to time this website
      may also include hyperlinks to other websites which are not maintained by
      Archery Association of India. These links are provided for your
      convenience only to provide further information. They do not signify that
      we endorse the website(s). We have no responsibility for the content of
      the linked website(s). Additional Undertakings These terms and conditions
      do not constitute the entire process for participating in all the archery
      competitions. On signing up of this agreement, the participant(s) may be
      required to enter into specific agreements or undertakings during separate
      events/ occasions. The terms therein may howsoever differ but not contrary
      to the terms stated herein. Revision of Terms and Conditions These terms
      and conditions are subject to amendments and shall be amended from time to
      time. We may revise these terms at any time by amending this page. Please
      check this page from time to time to take notice of any changes we made,
      as they are binding on you. Entire Agreement These Terms, including any
      legal notices and disclaimers contained on this Website, constitute the
      entire agreement between AAI and you/application and it members State
      Associations/Units in relation to your/applicants use of this Website, and
      supersede all prior agreements and understandings with respect to the
      same. Governing Law & Jurisdiction These terms and conditions are governed
      by the laws of India and the competent courts at New Delhi shall have
      exclusive jurisdiction. These Terms shall be governed by and construed
      under the laws of the Republic of India. You consent and agree that all
      legal proceedings relating to the subject matter of these Terms shall be
      maintained in courts sitting within the Republic of India, and that
      jurisdiction and venue for such proceedings shall lie exclusively with
      such courts.
      <br />

      <strong>Payments – Needs to be gone through</strong>

      <br />

      • Payment(s) through this Service may only be made with a Credit Card,
      Debit card or Net Banking. • Before using this Service, it is recommended
      that the user shall make necessary enquiry about the charges or fees
      payable against the Credit/Debit card used from Credit Card or the Debit
      Card service provider i.e. the respective Bank. • The credit card
      information supplied at the time of using the service is processed by the
      payment gateway of the service provider and is not supplied to AAI. It is
      the sole responsibility of the User of the service to ensure that the
      information entered in the relevant fields are correct. It is recommended
      that you take and retain a copy of the transaction for record keeping
      purposes, which might assist in resolution of any disputes that may arise
      out or usage of theservice. • The Applicant agrees, understands and
      confirms that his/ her personal data, including without limitation,
      details relating to debit card/ credit card/net banking transmitted over
      the Internet may be susceptible to misuse, hacking, theft and/ or fraud
      and that AAI or the Payment Service Provider(s) have no control over such
      matters. • The service is provided using a payment gateway service
      provider through a secured website. However, neither the payment gateway
      service provider nor the AAI gives any assurance, that the information so
      provided online by a user is secured or may be read or intercepted by a
      third party. AAI does not accept or assume any liability in the event of
      such unauthorized interception, hacking or other unauthorized access to
      information provided by a user of the service. • AAI and/or the Payment
      Service Providers shall not be liable for any inaccuracy, error or delay
      in, or omission of (a) any data, information or message, or (b) the
      transmission or delivery of any such data, information or message; or (c)
      any loss or damage arising from or occasioned by any such inaccuracy,
      error, delay or omission, non-performance or interruption in any such
      data, information or message. Under no circumstances shall the AAI and/or
      the Payment Service Providers, its employees, directors, and its third
      party agents involved in processing, delivering or managing the Services,
      be liable for any direct, indirect, incidental, special or consequential
      damages, or any damages whatsoever, including punitive or exemplary
      arising out of or in any way connected with the provision of or any
      inadequacy or deficiency in the provision of the Services or resulting
      from unauthorized access or alteration of transmissions of data or arising
      from suspension or termination of the Service. • The Applicant agrees that
      AAI or any of its employees will not be held liable by the Applicant for
      any loss or damages arising from your use of, or reliance upon the
      information contained on the Website, or any failure to comply with these
      Terms and Conditions where such failure is due to circumstance beyond
      AAI’s reasonable control. Debit/Credit Card, Bank Account Details: • The
      Applicant agrees that the debit/credit card details provided by him/ her
      for use of the aforesaid Service(s) must be correct and accurate. • The
      Applicant may pay his/ her permitted fees to AAI by using a debit/credit
      card or through online banking account. The Applicant warrants, agrees and
      confirms that when he/ she initiates a payment transaction and/or issues
      an online payment instruction and provides his/her card/bank details: •
      The Applicant is fully and lawfully entitled to use such credit / debit
      card, bank account for such transactions; • The Applicant is responsible
      to ensure that the card/ bank account details provided by him/ her are
      accurate; • The Applicant authorizes debit of the nominated card/ bank
      account for the Payment of fees selected by such Applicant along with the
      applicable Fees. Cancellation/Refund Policy Affiliation Fees once paid
      will not be refunded under any circumstances.
      <br />

      <strong>Privacy Policy</strong>

      <br />

      • In General, an Applicant / Member / Participant may browse this website
      for obtaining any data or information. However, in order to access the
      classified information, one needs to use the credentials provided as an
      Applicant / Member / participant. • The information provided by the user
      on this website shall be kept confidential and shall not be shared with
      anyone except AAI’s respective member units. Name, Date of Birth, State,
      photograph/action photograph, details of matches, scores and rankings. The
      AAI will adhere complete privacy norms as laid down under thelaw. • The
      DATA will neither be made accessible to third parties nor transferred in
      any form or manner unless required by law. • AAI may share your personal
      information with our bankers for clearing necessary fees payments. This
      information shall be strictly up to the legal permissible limit. • Online
      Fee Payment system purpose is to provide flexibility and conform to its
      continuing Member / Applicant by offering option to pay online using
      various payment methods. • It is sole responsibility of Applicant to pick
      online payment option. AAI do not recommend/ prefer/promote any particular
      method. • If payment is made by means of a card that you do not personally
      own, the permission of the card owner must always be obtained to make
      payments using the card. In using the system you confirm that you have
      such permission. • Information related to payments using debit or credit
      card is not accessed or stored by AAI.
      <br />

      <strong>ACKNOWLEGMENT OF RISK:</strong>

      <br />

      I knowingly, willingly and voluntarily acknowledge the inherent risks
      associated with participation in the sport of archery and understand that
      my participation in any Event involves risks and dangers including,
      without limitation, the potential for serious bodily injury, sickness and
      disease (including communicable diseases, virus or bacteria, Covid-19),
      trauma, pain & suffering, permanent disability, paralysis and death; loss
      of or damage to personal property; exposure to extreme conditions and
      circumstances; facilities or premises issues, including hazards resulting
      in slips, trips and falls; accidents involving other participants, event
      staff, volunteers, spectators or the general public; contact or exposure
      to other participants, including participants of varying skill levels;
      adverse weather conditions; travel risks; equipment failure, including
      protective equipment; inadequate safety measures; situations beyond the
      immediate control of the Event or Events organizers; and other undefined,
      not readily foreseeable and presently unknown risks and dangers (“Risks”).
      <br />

      <strong>ASSUMPTION OF RISK:</strong>

      <br />

      I understand that the aforementioned Risks may be caused in whole or in
      part or result directly or indirectly from the negligence of my own
      actions or inactions, the actions or inactions of others participating in
      or volunteering at the Events, or the negligent acts or omissions of the
      Released Parties defined below, and I hereby voluntarily and knowingly
      assume all such Risks and responsibility for any damages, liabilities,
      losses or expenses which I incur as a result of my participation in any
      Events.
      <br />

      <strong>WAIVER AND RELEASE OF LIABILITY, HOLD HARMLESS AND INDEMNITY:</strong>
      <br />

      In conjunction with my participation in any Events, I hereby release,
      waive and covenant not to sue, and further agree to indemnify, defend and
      hold harmless the following parties: Archery Association of India, its
      Executive Committee Members, its members State Archery
      Associations/Associate Members, Host Units, Event participants (including
      registered athletes, coaches, trainers, officials and other personnel),
      organizer, promoters, sponsors or advertisers of any Event or Events and
      all directors, officers, agents, administrators, contractors, employees or
      volunteers of any of the aforementioned parties (Individually and
      Collectively, the “Released Parties” or “Event Organizers”), with respect
      to any liability, claim(s), demand(s), cause(s) of action, damage(s), loss
      or expense (including court costs and reasonable attorney fees) of any
      kind or nature (“Liability”) which may arise out of, result from, or
      relate in any way to my participation in any Event or Event
      <br />

      <strong>PARENTAL CONSENT (IN CASE OF A MINOR):</strong>

      <br />

      In the case where the applicant is a minor, i.e. Archers below the age of
      18 years, it is understood that the parents/guardians of the participant
      are aware that preparation for and participation in the Archery
      competitions involves inherent risks [Detailed in Acknowledgment of Risk
      section above] of injuries to the participant and therefore, acknowledge
      and understand the danger of possible injuries in the sport. Parents/
      Guardians of Minor Archers give their unequivocal and unconditional
      consent to WAIVER AND RELEASE OF LIABILITY, HOLD HARMLESS AND INDEMNITY
      section above.
    </p>

  </div>

  <div class="footer-model-fixed">

    <p-checkbox [(ngModel)]="checked" (onChange)="checkIfAccepted($event)"
      label="You agree to Accept our Terms & Conditions" binary="true"></p-checkbox>

    <button class="authButton saveBut" (click)="submitRegister()" [disabled]="!checked">
      Accept
    </button>
  </div>


</p-dialog>

<p-dialog header="Godfather I" [(visible)]="emailVerifyModel"
  [dismissableMask]="true" [modal]="true" styleClass="mydialog" [responsive]="true" [minY]="70"
  [maximizable]="true" [baseZIndex]="10000">
    <form [formGroup]="emailVerificationFormGroup" (ngSubmit)="onVerifyCode()">
        <div>
          <h2 class="model-h2">Email Verification</h2>
          <p class="model-p text-success">* Enter 6 digit verification code has been sent to your registered email.</p>
          <p class="model-p text-danger">* If you don’t find it in your inbox, please check your Spam or Junk folder.</p>
          <div class="formcard-area">
            <div class="form-group-model">
              <label>Verification Code</label>
              <input  type="text" formControlName="verificationCode"/>
              <div style="justify-content: flex-end;">
                <div>
                  <div *ngIf="codeSubmited && v.verificationCode.errors">
                    <p *ngIf="v.verificationCode.errors.required" class=" model-p invalid-feedback">Verification code is required</p>
                    <p *ngIf="v.verificationCode.errors.pattern" class="model-p invalid-feedback">Verification code must be a six-digit number</p>
                  </div>
                </div>
                <div>
                  <p class="model-p" style="cursor: pointer" (click)="openVerifyModel()">Resend Otp</p>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group otp">
            <p-footer>
              <button class="model-but-save" style="background: gray" (click)="closeVerifyModel()" type="button">Close</button>
              <button class="model-but-close" style="background: linear-gradient(135deg, #44c1e6, #5160ca);" type="submit">Verify Otp</button>
            </p-footer>
          </div>
        </div>
    </form>
</p-dialog>